import { render, staticRenderFns } from "./with-draw.vue?vue&type=template&id=89bf9960&scoped=true"
import script from "./with-draw.vue?vue&type=script&lang=js"
export * from "./with-draw.vue?vue&type=script&lang=js"
import style0 from "./with-draw.vue?vue&type=style&index=0&id=89bf9960&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89bf9960",
  null
  
)

export default component.exports